import * as Sentry from '@sentry/vue'
import { TransactionEvent } from '@sentry/types'

export default defineNuxtPlugin((nuxtApp) => {
  const { vueApp } = nuxtApp
  const config = useRuntimeConfig()

  if (!config.public.isDeployed) return

  const regexMiioApiPattern = new RegExp('^' + config.public.miioApiUrl)
  const regexMiioServicesPattern = new RegExp('^' + config.public.miioServicesUrl)
  const regexMiioShopPattern = new RegExp('^' + config.public.miioShopUrl)

  Sentry.init({
    app: vueApp,
    dsn: config.public.sentry.dsn,
    enabled: true,
    release: config.public.versionCommitHash,
    integrations: [Sentry.browserTracingIntegration()],
    tracePropagationTargets: [regexMiioApiPattern, regexMiioServicesPattern, regexMiioShopPattern],

    beforeSendTransaction(transaction: TransactionEvent): TransactionEvent | null {
      const shouldSendTransaction = Boolean(Math.floor(Math.random() * 100) === 0)
      if (transaction.spans && transaction.spans.length > 0) {
        if (transaction.spans.every((span) => span.status === 'ok' || span.status === 'unknown')) {
          return shouldSendTransaction ? transaction : null
        }
      } else if (transaction.contexts?.trace?.status === 'ok' || transaction.contexts?.trace?.status === 'unknown') {
        return shouldSendTransaction ? transaction : null
      }
      return transaction
    },
    tracesSampler: (samplingContext) => {
      const supportedTransactionNames = [
        'store_checkout_web',
        'store_retry_payment_web',
        'store_checkout_summary_page_web',
        'store_checkout_vat_creation_web',
        'child_store_make_order_payment_web',
        'store_make_order_payment_task_web'
      ]
      if (supportedTransactionNames.includes(samplingContext.transactionContext.name)) {
        return 1.0
      }
      return 0.0
    }
  })
})
